import { useRuntimeConfig } from "nuxt/app";

export const useTracking = () => {
    const runtimeConfig = useRuntimeConfig();
    const isTrackingEnabled = process.client && runtimeConfig.public.environment === 'prod';

    const initGoogleAds = (googleId: string) => {
        if (!googleId) return;
        if (!isTrackingEnabled) return; // run only on prod
        if (window.gtag) return;

         // Initialize dataLayer before loading gtag
        window.dataLayer = window.dataLayer || [];

        window.gtag = function () {
            window.dataLayer.push(arguments);
        };

        window.gtag('js', new Date());
        window.gtag('config', googleId);

        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${googleId}`;

        document.head.appendChild(script);
    };

    const initMetaPixel = (pixelId: string) => {
        if (!pixelId) return;
        if (!isTrackingEnabled) return;
        if (window.fbq) return;

        !(function (f, b, e, v, n, t, s) {
            if (f.fbq) return;

            n = f.fbq = function () {
                n.callMethod
                    ? n.callMethod.apply(n, arguments)
                    : n.queue.push(arguments);
            };

            if (!f._fbq) f._fbq = n;

            n.push = n;
            n.loaded = true;
            n.version = '2.0';
            n.queue = [];

            t = b.createElement(e);
            t.async = true;
            t.src = v;

            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
        })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

        window.fbq('init', pixelId);
        window.fbq('track', 'PageView');
    };

    const trackGoogleConversion = (sendTo: string) => {
        if (!sendTo) return;
        if (!isTrackingEnabled) return;

        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
            event: 'google_ads_conversion',
            send_to: sendTo,
        });
    };

    const trackMetaSchedule = () => {
        if (!isTrackingEnabled) return;
        if (!window.fbq) return;
        window.fbq('track', 'Schedule');
    };

    return {
        initGoogleAds,
        initMetaPixel,
        trackGoogleConversion,
        trackMetaSchedule,
    };
};
